module.exports = __webpack_public_path__ + "static/shifter-wildhunt-1-846761dbdf8b3a52772cbbebeec707b1.png";